import React, { PureComponent } from 'react';

import ArrowDown from '../../../../assets/arrow_down.png';
import ArrowUp from '../../../../assets/arrow_up.png';
import { ErrorText } from '../../molecules';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class Select extends PureComponent {
  render() {
    const {
      options = [],
      fullWidth,
      className,
      innerRef,
      onMouseOver,
      onMouseOut,
      defaultValue,
      inputStyle,
      value,
      errorText,
      ...props
    } = this.props;

    return (
      <div onMouseOver={onMouseOver} onMouseOut={onMouseOut} ref={innerRef}>
        <ReactSelect
          options={options}
          className={cx('Select', { fullWidth }, className)}
          styles={{
            control: (provided, state) => ({
              ...provided,
              height: 50,
              minHeight: 50,
              borderColor: errorText ? '#d52121' : state.menuIsOpen ? '#212121' : '#ddd',
              borderRadius: 3,
              '&:hover': { cursor: 'pointer' },
              svg: {
                display: 'none',
              },
              boxShadow: 'none',
              '>div:last-child': { width: '30px' },
              "div[aria-hidden='true']": {
                height: '100%',
                backgroundImage: `url(${state.menuIsOpen ? ArrowUp : ArrowDown})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '14px 8px',
                backgroundPosition: '0 21.5px',
              },
              ...inputStyle,
            }),

            option: (provided, state) => ({
              ...provided,
              fontWeight: state.isSelected ? 'bold' : 'normal',
              backgroundColor: state.isSelected ? '#f6f6f6' : '#fff',
              color: '#212121',
              height: '50px',
              lineHeight: '35px',
              '&:hover': { backgroundColor: '#eee' },
            }),
            menu: (provided) => ({
              ...provided,
              border: 'solid 1px #212121',
              borderRadius: 3,
            }),
            singleValue: (provided, state) => {
              const opacity = state.isDisabled ? 0.5 : 1;
              const transition = 'opacity 300ms';
              const color = '#212121';
              const lineHeight = 'normal';
              return { ...provided, opacity, color };
            },
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary25: '#f6f6f6',
              primary: '#212121',
            },
          })}
          components={{
            IndicatorSeparator: () => null,
          }}
          value={value ? { label: value?.label, value: value?.value } : null}
          {...props}
        />
        {errorText && <ErrorText style={{ marginTop: 5 }}>{errorText}</ErrorText>}
      </div>
    );
  }
}

Select.propTypes = {
  fullWidth: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <Select innerRef={ref} {...props} />);
